<template>
  <div class="page-container">
    <div class="return" @click="back">
      <img class="backImg" src="@/assets/images/back.png" alt />
    </div>
    
    <el-dialog title="开单" :visible.sync="addOrderDialogVisible"   :close-on-click-modal="false"   width="70%">
      <addOrder ref="addOrder" :customerDetail="customerDetail" @order-detail="handleOrderDetail" />
    </el-dialog>


    <div class="paper-form">
      <!-- 表头 -->
      <div class="form-title">
        <div>
          <h2>{{ medical_title }}</h2>
          <div style="display: flex; align-items: center;justify-content: center;">
            <h2>{{formData.case_type==2 ? '复诊病历' : '门诊病历' }}</h2>
            <!-- <span style="font-size:14px; color:#333;">（光电 / 注射 / 水光 / 微针 / 皮下剥离）</span> -->
          </div>
        </div>
        <div style="font-size:14px; text-align:right;padding-right:20px;font-weight:bold;">
         {{formData.case_no}}
        </div>
      </div>

      <el-form
        ref="formRef"
        :model="formData"
        label-suffix="："
        size="mini"
        class="medical-form"
        @submit.native.prevent
      >
        <div class="form-row">
          <div class="form-label">基本信息</div>
          <div class="form-content">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="科室">
                  <el-input v-model="formData.department" class="w140" placeholder="" clearable />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="姓名">
                  <el-input v-model="formData.customer_name" placeholder="" class="w140" clearable />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="性别">
                  <el-radio-group v-model="formData.customer_sex">
                    <el-radio :label="1">男</el-radio>
                    <el-radio :label="2">女</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="年龄">
                  <el-input v-model="formData.age" class="w80" placeholder="" clearable />
                  <span class="unit">岁</span>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>

        <!-- 主诉部分 -->
        <div class="form-row">
          <div class="form-label">主诉</div>
          <div class="form-content">
            <div class="select-tip-wrapper">
              <span class="tip-icon">快速选择：</span>
              <el-select
                v-model="selectedChiefList"
                placeholder="搜索或选择主诉模板"
                clearable
                filterable
                multiple
                collapse-tags
                reserve-keyword
                remote
                :remote-method="chiefRemoteMethod"
                @change="handleChiefChange"
                class="select-template"
                size="small"
              >
                <el-option
                  v-for="item in options.chiefList"
                  :key="item.id"
                  :label="item.content"
                  :value="item.id"
                />
              </el-select>
            </div>
            <el-input
              v-model="formData.principle_action"
              type="textarea"
              :rows="3"
              placeholder="详细描述主诉内容，可从上方选择后自动生成"
              class="textarea-content"
            />
          </div>
        </div>

        <!-- 现病史部分 -->
        <div class="form-row">
          <div class="form-label">现病史</div>
          <div class="form-content">
            <div class="select-tip-wrapper">
              <span class="tip-icon">快速选择：</span>
              <el-select
                v-model="selectedNowMedicalList"
                placeholder="搜索或选择现病史模板"
                clearable
                filterable
                multiple
                collapse-tags
                reserve-keyword
                remote
                :remote-method="meRecordRemoteMethod"
                @change="handleNowMedicalChange"
                class="select-template"
                size="small"
              >
                <el-option
                  v-for="item in options.meRecordList"
                  :key="item.id"
                  :label="item.content"
                  :value="item.id"
                />
              </el-select>
            </div>
            <el-input
              v-model="formData.now_medical_history"
              type="textarea"
              :rows="4"
              placeholder="详细描述现病史，可从上方选择后自动生成"
              class="textarea-content"
            />
          </div>
        </div>

        <div class="form-row" v-if="previous_history.children && previous_history.children.length && formData.case_type == 1">
          <div class="form-label">既往史</div>
          <div class="form-content">
            <template v-for="item in previous_history.children">
              <div :key="item.second_level_head || item.id" v-if="item.label !== undefined && item.children && item.children.length" >
                <div class="sub-label" v-if="item.label">{{ item.label }}</div>
                <div class="check-list">
                  <div v-for="child in item.children" :key="child.id" class="check-item">
                    <el-checkbox
                      v-if="child.is_show_checkbox === 1 && child.content"
                      v-model="formData.checkboxMap[child.id]"
                      size="small"
                    />
                    <span v-if="child.content && child.is_show_checkbox === 1" class="text">{{ child.content }}</span>
                    <span v-if="child.content && child.is_show_checkbox !== 1" class="text">{{ child.content }}</span>
                    <el-input
                      v-if="child.is_show_input === 1"
                      v-model="formData.inputMap[child.id]"
                      :placeholder="'请输入' + (child.content || '')"
                      size="small"
                      clearable
                      class="input-inline"
                    />
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>

        <div class="form-row" v-if="physical_examination.children && physical_examination.children.length">
          <div class="form-label">查体</div>
          <div class="form-content">
            <div class="select-tip-wrapper">
              <span class="tip-icon">快速选择：</span>
              <el-select
                v-model="selectedPhysicalExaminationList"
                placeholder="搜索或选择查体结果模板"
                clearable
                filterable
                multiple
                collapse-tags
                reserve-keyword
                remote
                :remote-method="physicalExaminationRecordRemoteMethod"
                @change="handlePhysicalExaminationChange"
                class="select-template"
                size="small"
              >
                <el-option
                  v-for="item in options.physicalExaminationRecordList"
                  :key="item.id"
                  :label="item.content"
                  :value="item.id"
                />
              </el-select>
            </div>
            <el-input
              v-model="formData.physical_examination_front"
              type="textarea"
              :rows="4"
              placeholder="详细描述查体结果，可从上方选择后自动生成"
              class="textarea-content"
            />



            <template v-for="item in physical_examination.children">
              <div :key="item.second_level_head || item.id" v-if="item.label !== undefined && item.children && item.children.length">
                <div class="sub-label" v-if="item.label">{{ item.label }}</div>
                <div class="check-list">
                  <div v-for="child in item.children" :key="child.id" class="check-item">
                    <el-checkbox
                      v-if="child.is_show_checkbox === 1 && child.content"
                      v-model="formData.checkboxMap[child.id]"
                      size="small"
                    />
                    <span v-if="child.content" class="text">{{ child.content }}</span>
                    <el-input
                      v-if="child.is_show_input === 1"
                      v-model="formData.inputMap[child.id]"
                      :placeholder="'请输入' + (child.content || '')"
                      size="small"
                      clearable
                      class="input-inline"
                    />
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>

        <!-- 个人史部分 -->
        <div class="form-row">
          <div class="form-label">个人史</div>
          <div class="form-content">
            <div class="select-tip-wrapper">
              <span class="tip-icon">快速选择：</span>
              <el-select
                v-model="selectedPersonalMedicalList"
                placeholder="搜索或选择个人史模板"
                clearable
                filterable
                multiple
                collapse-tags
                reserve-keyword
                remote
                :remote-method="personalRecordRemoteMethod"
                @change="handlePersonalMedicalChange"
                class="select-template"
                size="small"
              >
                <el-option
                  v-for="item in options.personalRecordList"
                  :key="item.id"
                  :label="item.content"
                  :value="item.id"
                />
              </el-select>
            </div>
            <el-input
              v-model="formData.personal_history"
              type="textarea"
              :rows="4"
              placeholder="详细描述个人史，可从上方选择后自动生成"
              class="textarea-content"
            />
          </div>
        </div>

        <!-- 家族史部分 -->
        <div class="form-row">
          <div class="form-label">家族史</div>
          <div class="form-content">
            <div class="select-tip-wrapper">
              <span class="tip-icon">快速选择：</span>
              <el-select
                v-model="selectedFamilyMedicalList"
                placeholder="搜索或选择家族史模板"
                clearable
                filterable
                multiple
                collapse-tags
                reserve-keyword
                remote
                :remote-method="familyRecordRemoteMethod"
                @change="handleFamilyMedicalChange"
                class="select-template"
                size="small"
              >
                <el-option
                  v-for="item in options.familyRecordList"
                  :key="item.id"
                  :label="item.content"
                  :value="item.id"
                />
              </el-select>
            </div>
            <el-input
              v-model="formData.family_history"
              type="textarea"
              :rows="4"
              placeholder="详细描述家族史，可从上方选择后自动生成"
              class="textarea-content"
            />
          </div>
        </div>


        

        <div class="form-row" v-if="diagnosis.children && diagnosis.children.length">
          <div class="form-label">诊断</div>
          <div class="form-content">
            <div class="check-list">
              <template v-for="group in diagnosis.children">
                <div v-for="item in group.children" :key="item.id" class="check-item">
                  <el-checkbox
                    v-if="item.is_show_checkbox === 1 && item.content"
                    v-model="formData.checkboxMap[item.id]"
                    size="small"
                  />
                  <span v-if="item.content" class="text">{{ item.content }}</span>
                  <el-input
                    v-if="item.is_show_input === 1"
                    v-model="formData.inputMap[item.id]"
                    :placeholder="'请输入' + (item.content || '')"
                    size="small"
                    clearable
                    class="input-inline"
                  />
                </div>
              </template>
            </div>
          </div>
        </div>

       <div class="form-row" v-if="doctor_advice.children && doctor_advice.children.length">
        <div class="form-label">治疗医嘱</div>
        <div class="form-content">
          <div class="check-list">
            <template v-for="group in doctor_advice.children">
              <div v-for="item in group.children" :key="item.id" class="check-item">
                <el-checkbox
                  v-if="item.is_show_checkbox === 1 && item.content"
                  v-model="formData.checkboxMap[item.id]"
                  size="small"
                  @change="() => handleCheckboxChange()"
                />
                <span v-if="item.content" class="text">{{ item.content }}</span>
                <el-input
                  v-if="item.is_show_input === 1"
                  v-model="formData.inputMap[item.id]"
                  :placeholder="'请输入' + (item.content || '')"
                  size="small"
                  clearable
                  class="input-inline"
                />
              </div>
            </template>
          </div>
          <!-- 按钮仅在存在选中医嘱时显示，并靠右对齐 -->
          <div class="btn-wrapper" v-if="hasCheckedAdvice">
            <el-button type="primary" size="small" @click="tapBtn">去开单</el-button>
          </div>
        </div>
      </div>

        <div class="form-row" >
          <div class="form-label">治疗记录</div>
          <div class="form-content">
            <div style="display: flex; gap: 10px; align-items: baseline; margin-bottom: 15px;">
              <div class="sub-label">治疗时间</div>
              <el-date-picker
                v-model="formData.treatment_time"
                type="datetime"
                placeholder="请选择治疗时间"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                class="date-picker"
                size="small"
              />
            </div>
            <div v-if="treatment_record.children && treatment_record.children.length">
              <template v-for="item in treatment_record.children">
                <div :key="item.second_level_head || item.id">
                  <div class="sub-label" v-if="item.label">{{ item.label }}</div>
                  <div class="check-list" v-if="item.children && item.children.length">
                    <div v-for="child in item.children" :key="child.id" class="check-item">
                      <el-checkbox
                        v-if="child.is_show_checkbox === 1 && child.content"
                        v-model="formData.checkboxMap[child.id]"
                        size="small"
                      />
                      <span v-if="child.content" class="text">{{ child.content }}</span>
                      <el-input
                        v-if="child.is_show_input === 1"
                        v-model="formData.inputMap[child.id]"
                        :placeholder="'请输入' + (child.content || '')"
                        size="small"
                        clearable
                        class="input-inline"
                      />
                    </div>
                  </div>
                </div>
              </template>
            </div>

            <div style="margin-top: 15px;">
              <div class="sub-label">治疗步骤/方法、治疗设备应用技术参数(能量、时长)等</div>
              <el-input
                type="textarea"
                :rows="4"
                autosize
                v-model="formData.steps_methods"
                placeholder="请详细填写治疗步骤、方法、设备参数、能量、时长等信息"
                class="textarea-content"
              />
            </div>
          </div>
        </div>

        <!-- 接诊医师 -->
        <div class="form-row">
          <div class="form-label">医师</div>
          <div class="form-content">
            <img v-if="formData.sign_img" :src="'data:image/png;base64,' + formData.sign_img" alt="签名图片" />
            <span v-else>暂无签名</span>
          </div>
          <div>
            <div v-if="orderDetail.total_amount">
              订单总金额：<span style="color: #d32f2f; font-weight: 600;">{{orderDetail.total_amount }}</span>
            </div>
            <div style="margin-top: 10px;" v-if="orderDetail.unpaid_amount && orderDetail.unpaid_amount > 0">
              待支付：<span style="color: #ff9800; font-weight: 600;">{{orderDetail.unpaid_amount }}</span>
            </div>
          </div>
        </div>

        <!-- 备注 -->
        <div class="tips-text">
          <i class="el-icon-info"></i>
          注：勾选适用的内容，或在其他栏补充，不适用的病史诊断、未使用的治疗均不勾选，后续子项也不再填写。
        </div>

        <!-- 按钮区 -->
        <div class="btn-group">
          <el-button size="medium" @click="back">取消</el-button>
          <el-button type="primary" size="medium" @click="handleSubmit" :loading="submitting">提交保存</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getCaseTree, addCase, updateCase, getCaseTreeTwo, getCasePrecautions, getPersonSign, getCaseDetail ,checkMedicalCase} from '@/api/client'
import addOrder from './orderAdd.vue'

import { mapGetters } from 'vuex'

class FormData {
    case_id = null
    case_no = ""
    case_number = ""
    department = ""
    customer_name = ""
    sign_img = ""
    e_signature_doctor = ""
    doctor_name = ""
    customer_sex = null
    age = ""
    doctor_id = ""
    principle_action = ""
    now_medical_history = ""
    physical_examination_front = ""
    personal_history = ""
    family_history  = ""
    treatment_time = ""
    steps_methods = ""
    checkboxMap = {}
    inputMap = {}
    customerId = ""
    case_type = ""
}
class Options {
    chiefList = []
    meRecordList = []
    personalRecordList = []
    familyRecordList = []
}

export default {
  name: "MedicalRecord",
  data() {
    return {
      orderDetail: {},
      customerDetail: {},
      addOrderDialogVisible: false,
      isEditMode: false,
      customerInfo: {},
      options: new Options(),
      submitting: false,
      loading: false,
      principle_action: {},
      now_medical_history: {},
      personal_history: {},
      family_history: {},
      physical_examination: {},
      previous_history: {},
      physical_examination_front: {},
      diagnosis: {},
      treatment_record: {},
      doctor_advice: {},
      selectedChiefList: [],
      selectedNowMedicalList: [],
      selectedPhysicalExaminationList: [],
      selectedFamilyMedicalList:[],
      selectedPersonalMedicalList:[],
      formData: new FormData(),
      medical_title :''
    };
  },
  components: {
    addOrder
  },
  computed: {
    ...mapGetters(['userInfo']),
    hasCheckedAdvice() {
      if(this.formData.case_type === 2) return false
      if(this.isEditMode) return false
      if (!this.doctor_advice?.children) return false
      for (const group of this.doctor_advice.children) {
        if (group.children && group.children.length) {
          for (const item of group.children) {
            if (item.is_show_checkbox === 1 && this.formData.checkboxMap[item.id]) {
              return true
            }
          }
        }
      }
      return false
    },
    selectedDoctorAdviceIds() {
      if (!this.doctor_advice.children) return [];
      const selectedIds = [];
      this.doctor_advice.children.forEach(group => {
        if (group.children && group.children.length) {
          group.children.forEach(item => {
            if (this.formData.checkboxMap[item.id]) {
              selectedIds.push(item.id);
            }
          });
        }
      });
      return selectedIds;
    }
  },
  methods: {
    handleOrderDetail(detail) {
      this.orderDetail = { ...detail }; 
      this.addOrderDialogVisible = false
      console.log(detail,"传过来的detail")
    },
    tapBtn() {
        this.addOrderDialogVisible = true
    },

    processModuleData(children) {
      if (!children || !children.length) return [];
      const normalItems = [];
      const groupItems = [];
      children.forEach(item => {
        if (item.second_level_head || (item.children && item.children.length)) {
          groupItems.push(item);
        } else {
          normalItems.push(item);
        }
      });
      if (normalItems.length) {
        groupItems.unshift({
          label: "",
          second_level_head: "",
          children: normalItems,
        });
      }
      return groupItems;
    },

    async getPersonSign() {
      try {
        const res = await getPersonSign({
          person_id: this.userInfo.shop_person_id
        })
        this.formData.e_signature_doctor = res.id || {}
        this.formData.sign_img = res.sign_img || ''
        this.formData.doctor_name = res.name || this.userInfo.name || ''
      } catch (err) {
        console.error('获取签名失败:', err)
      }
    },

    async handleCheckboxChange() {
        const selectedIds = this.selectedDoctorAdviceIds;
        if (selectedIds.length === 0) {
          this.formData.steps_methods = '';
          return;
        }
        try {
          const res = await getCasePrecautions({
            advice_ids: selectedIds.join(',')
          });
          this.handlePrecautionsData(res);
        } catch (err) {
          this.$message.error(err);
        }
    },

    handlePrecautionsData(data) {
     if (data && Array.isArray(data) && data.length > 0) {
        this.formData.steps_methods = data
          .map((item, index) => `${index + 1}：${item.precautions}`)
          .join('\n');
      } else {
        this.formData.steps_methods = '';
      }
    },

    async chiefRemoteMethod(keyword) {
      try {
        const res = await getCaseTreeTwo({
          keyword: keyword || '',
          first_level_head: 7,
        })
        this.options.chiefList = res || []
      } catch (err) {
        this.$message.error(err.message || '加载主诉模板失败')
      }
    },

    handleChiefChange(selectedValues) {
      const selectedLabels = selectedValues.map(val => {
        const item = this.options.chiefList.find(i => i.id === val);
        return item ? item.content : '';
      }).filter(Boolean);
      if (selectedLabels.length) {
        this.formData.principle_action = selectedLabels.join('；');
      } else {
        this.formData.principle_action = '';
      }
    },

    async meRecordRemoteMethod(keyword) {
      try {
        const res = await getCaseTreeTwo({
          keyword: keyword || '',
          first_level_head: 1,
        })
        this.options.meRecordList = res || []
      } catch (err) {
        this.$message.error(err.message || '加载现病史模板失败')
      }
    },

    handleNowMedicalChange(selectedValues) {
      const selectedLabels = selectedValues.map(val => {
        const item = this.options.meRecordList.find(i => i.id === val);
        return item ? item.content : '';
      }).filter(Boolean);
      if (selectedLabels.length) {
        this.formData.now_medical_history = selectedLabels.join('；');
      } else {
        this.formData.now_medical_history = '';
      }
    },
    async physicalExaminationRecordRemoteMethod(keyword) {
      try {
        const res = await getCaseTreeTwo({
          keyword: keyword || '',
          first_level_head: 33,
        })
        this.options.physicalExaminationRecordList = res || []
      } catch (err) {
        this.$message.error(err.message || '加载查体模板失败')
      }
    },
    handlePhysicalExaminationChange(selectedValues) {
      const selectedLabels = selectedValues.map(val => {
        const item = this.options.physicalExaminationRecordList.find(i => i.id === val);
        return item ? item.content : '';
      }).filter(Boolean);
      if (selectedLabels.length) {
        this.formData.physical_examination_front = selectedLabels.join('；');
      } else {
        this.formData.physical_examination_front = '';
      }
    },

    //个人史------begin
    async personalRecordRemoteMethod(keyword) {
      try {
        const res = await getCaseTreeTwo({
          keyword: keyword || '',
          first_level_head: 30,
        })
        this.options.personalRecordList = res || []
      } catch (err) {
        this.$message.error(err.message || '加载个人史模板失败')
      }
    },

    handlePersonalMedicalChange(selectedValues) {
      const selectedLabels = selectedValues.map(val => {
        const item = this.options.personalRecordList.find(i => i.id === val);
        return item ? item.content : '';
      }).filter(Boolean);
      if (selectedLabels.length) {
        this.formData.personal_history = selectedLabels.join('；');
      } else {
        this.formData.personal_history = '';
      }
    },
    //个人史------end

    //家族史------begin
    async familyRecordRemoteMethod(keyword) {
      try {
        const res = await getCaseTreeTwo({
          keyword: keyword || '',
          first_level_head: 31,
        })
        this.options.familyRecordList = res || []
      } catch (err) {
        this.$message.error(err.message || '加载家族史模板失败')
      }
    },

    handleFamilyMedicalChange(selectedValues) {
      const selectedLabels = selectedValues.map(val => {
        const item = this.options.familyRecordList.find(i => i.id === val);
        return item ? item.content : '';
      }).filter(Boolean);
      if (selectedLabels.length) {
        this.formData.family_history = selectedLabels.join('；');
      } else {
        this.formData.family_history = '';
      }
    },
    //家族史------end




    initFormValueRecursive(items) {
      if (!items || !items.length) return;
      items.forEach(item => {
        if (item.is_show_checkbox === 1) {
          this.$set(this.formData.checkboxMap, item.id, false);
        }
        if (item.is_show_input === 1) {
          this.$set(this.formData.inputMap, item.id, "");
        }
        if (item.children && item.children.length) {
          this.initFormValueRecursive(item.children);
        }
      });
    },

    async getCaseList() {
      this.loading = true
      try {
        const res = await getCaseTree()
        this.principle_action = res.principle_action || {}
        this.now_medical_history = res.now_medical_history || {}
        this.physical_examination = res.physical_examination || {}
        this.previous_history = res.previous_history || {}
        this.diagnosis = res.diagnosis || {}
        this.treatment_record = res.treatment_record || {}
        this.doctor_advice = res.doctor_advice || {}
        this.previous_history.children = this.processModuleData(this.previous_history.children);
        this.physical_examination.children = this.processModuleData(this.physical_examination.children);
        this.diagnosis.children = this.processModuleData(this.diagnosis.children);
        this.doctor_advice.children = this.processModuleData(this.doctor_advice.children);
        this.treatment_record.children = this.processModuleData(this.treatment_record.children);

        this.initFormValue()
        if (this.isEditMode && this.formData.case_id) {
          await this.loadCaseDetail()
        }
      } catch (err) {
        this.$message.error(err.message || '加载模板失败')
      } finally {
        this.loading = false
      }
    },

    async loadCaseDetail() {
      try {
        const res = await getCaseDetail({ id: this.formData.case_id })
        if (res) {
          this.formData.case_no = res.case_no
          this.setCaseDataToForm(res)
        }
      } catch (err) {
        this.$message.error(err.message || '加载病历详情失败')
      }
    },

    setCaseDataToForm(caseData) {
      this.formData.id = caseData.id
      this.formData.sign_img = caseData.sign || ''
      this.formData.case_number = caseData.case_number || ''
      this.formData.department = caseData.department || ''
      this.formData.customer_name = caseData.customer_name || ''
      this.formData.customer_sex = caseData.customer_sex || null
      this.formData.age = caseData.age || ''
      this.formData.principle_action = caseData.principle_action || ''
      this.formData.now_medical_history = caseData.now_medical_history || ''
      this.formData.physical_examination_front = caseData.physical_examination_front || ''
      //新增个人史/家族史-begin
      this.formData.personal_history = caseData.personal_history || ''
      this.formData.family_history = caseData.family_history || ''
      //新增个人史/家族史-end
      this.formData.treatment_time = caseData.treatment_time || ''
      if (Array.isArray(caseData.steps_methods)) {
        this.formData.steps_methods = caseData.steps_methods.join('\n')
      } else {
        this.formData.steps_methods = caseData.steps_methods || ''
      }
      this.formData.doctor_id = caseData.doctor_id || ''
      this.formData.e_signature_doctor = caseData.e_signature_doctor || ''
      this.formData.e_signature_patient = caseData.e_signature_patient || ''
      this.formData.case_type = caseData.case_type || ''

      if (this.formData.principle_action && this.options.chiefList.length) {
        const matchedIds = this.options.chiefList
          .filter(item => this.formData.principle_action.includes(item.content))
          .map(item => item.id)
        this.selectedChiefList = matchedIds
      }
      if (this.formData.now_medical_history && this.options.meRecordList.length) {
        const matchedIds = this.options.meRecordList
          .filter(item => this.formData.now_medical_history.includes(item.content))
          .map(item => item.id)
        this.selectedNowMedicalList = matchedIds
      }
      //查体前边的内容
      if (this.formData.physical_examination_front && this.options.physicalExaminationRecordList.length) {
        const matchedIds = this.options.physicalExaminationRecordList
          .filter(item => this.formData.physical_examination_front.includes(item.content))
          .map(item => item.id)
        this.selectedPhysicalExaminationList = matchedIds
      }
      //个人史
      if (this.formData.personal_history && this.options.personalRecordList.length) {
        const matchedIds = this.options.personalRecordList
          .filter(item => this.formData.personal_history.includes(item.content))
          .map(item => item.id)
        this.selectedPersonalMedicalList = matchedIds
      }
      //家族史
      if (this.formData.family_history && this.options.familyRecordList.length) {
        const matchedIds = this.options.familyRecordList
          .filter(item => this.formData.family_history.includes(item.content))
          .map(item => item.id)
        this.selectedFamilyMedicalList = matchedIds
      }
      this.echoModuleData('previous_history', caseData.previous_history)
      this.echoModuleData('physical_examination', caseData.physical_examination)
      this.echoModuleData('diagnosis', caseData.diagnosis)
      this.echoModuleData('doctor_advice', caseData.doctor_advice)
      this.echoModuleData('treatment_record', caseData.treatment_record)
    },

    buildItemIdMap(items) {
      const idMap = new Map()
      if (!items) return idMap
      
      items.forEach(item => {
        idMap.set(item.id, item)
        if (item.children && item.children.length) {
          const childMap = this.buildItemIdMap(item.children)
          childMap.forEach((value, key) => idMap.set(key, value))
        }
      })
      return idMap
    },

    echoModuleData(moduleName, moduleData) {
      if (!moduleData || !moduleData.length) return
      
      const moduleConfig = this[moduleName]
      if (!moduleConfig || !moduleConfig.children) return
      
      const allItemsMap = this.buildItemIdMap(moduleConfig.children)
      
      moduleData.forEach(moduleItem => {
        const { checkedIds = [], inputValues = {} } = moduleItem
        
        checkedIds.forEach(id => {
          if (allItemsMap.has(id)) {
            this.$set(this.formData.checkboxMap, id, true)
          }
        })
        
        Object.keys(inputValues).forEach(id => {
          const numId = Number(id)
          if (allItemsMap.has(numId)) {
            this.$set(this.formData.inputMap, numId, inputValues[id])
          }
        })
      })
    },

    initFormValue() {
      this.formData.checkboxMap = {}
      this.formData.inputMap = {}
      if (!this.formData.steps_methods) {
        this.formData.steps_methods = ''
      }
      const modules = [
        this.previous_history,
        this.physical_examination,
        this.diagnosis,
        this.doctor_advice,
        this.treatment_record
      ];
      modules.forEach(module => {
        if (module.children && module.children.length) {
          this.initFormValueRecursive(module.children);
        }
      });
    },

    extractModuleDataRecursive(items) {
      if (!items || !items.length) return { checkedIds: [], inputValues: {} };
      let checkedIds = [];
      let inputValues = {};
      items.forEach(item => {
        if (this.formData.checkboxMap[item.id]) {
          checkedIds.push(item.id);
        }
        if (this.formData.inputMap[item.id]?.trim()) {
          inputValues[item.id] = this.formData.inputMap[item.id].trim();
        }
        if (item.children && item.children.length) {
          const childData = this.extractModuleDataRecursive(item.children);
          checkedIds = [...checkedIds, ...childData.checkedIds];
          inputValues = { ...inputValues, ...childData.inputValues };
        }
      });
      return { checkedIds, inputValues };
    },

    buildSubmitData() {
      const extractModuleData = (module) => {
        if (!module.children) return []
        const moduleData = []
        
        module.children.forEach(item => {
          if (item.children && item.children.length) {
            const { checkedIds, inputValues } = this.extractModuleDataRecursive(item.children);
            if (checkedIds.length || Object.keys(inputValues).length) {
              moduleData.push({
                second_level_head: item.second_level_head || item.label || '',
                checkedIds: checkedIds,
                inputValues: inputValues
              })
            }
          } 
          else {
            const isChecked = this.formData.checkboxMap[item.id]
            const hasInput = this.formData.inputMap[item.id]?.trim()
            
            if (isChecked || hasInput) {
              let existingItem = moduleData.find(d => d.second_level_head === (item.label || ''))
              if (!existingItem) {
                existingItem = {
                  second_level_head: item.label || '',
                  checkedIds: [],
                  inputValues: {}
                }
                moduleData.push(existingItem)
              }
              if (isChecked) existingItem.checkedIds.push(item.id)
              if (hasInput) existingItem.inputValues[item.id] = this.formData.inputMap[item.id].trim()
            }
          }
        })
        
        return moduleData
      }
      
      return {
        previous_history: extractModuleData(this.previous_history),
        physical_examination: extractModuleData(this.physical_examination),
        diagnosis: extractModuleData(this.diagnosis),
        doctor_advice: extractModuleData(this.doctor_advice),
        treatment_record: extractModuleData(this.treatment_record)
      }
    },

    validateForm() {
      if (!this.formData.customer_name) {
        this.$message.warning('请填写姓名')
        return false
      }
      if (this.formData.customer_sex === null || this.formData.customer_sex === undefined) {
        this.$message.warning('请选择性别')
        return false
      }
      if (!this.formData.age) {
        this.$message.warning('请填写年龄')
        return false
      }
      if (!this.formData.department) {
        this.$message.warning('请填写科室')
        return false
      }
      return true
    },

    async handleSubmit() {
      if (!this.validateForm()) return
      this.submitting = true
      const moduleData = this.buildSubmitData()
      const submitData = {
        physical_examination_front: this.formData.physical_examination_front,
        id: this.formData.case_id,
        shop_id: this.customerInfo.shop_id,
        customer_id: this.formData.customerId,
        customer_name: this.formData.customer_name,
        customer_sex: this.formData.customer_sex,
        age: this.formData.age,
        department: this.formData.department,
        case_type: this.formData.case_type,
        principle_action: this.formData.principle_action,
        now_medical_history: this.formData.now_medical_history,
        personal_history: this.formData.personal_history,
        family_history: this.formData.family_history,
        previous_history: moduleData.previous_history,
        physical_examination: moduleData.physical_examination,
        diagnosis: moduleData.diagnosis,
        doctor_advice: moduleData.doctor_advice,
        treatment_record: moduleData.treatment_record,
        doctor_id: this.userInfo.shop_person_id || 79,
        e_signature_doctor: this.formData.e_signature_doctor,
        treatment_time: this.formData.treatment_time,
        steps_methods: this.formData.steps_methods,
        order: this.orderDetail
      }
      if (this.isEditMode && this.formData.case_id) {
        submitData.case_id = this.formData.case_id
      }
      console.log(submitData)
      try {
        if (this.isEditMode) {
          await updateCase(submitData)
          this.$message.success('更新成功')
        } else {
          await addCase(submitData)
          this.$message.success('保存成功')
        }
        this.back()
      } catch (err) {
        console.log(err)
        this.$message.error(err)
      } finally {
        this.submitting = false
      }
    },
    back(){
      const query = {
        detail: this.$route.query.detail,
        id: this.formData.customerId,
        activeName: "fourteen1",
      };
      this.$router.push({ name: "客户详情", query });
    },
    isFirstCase(){
      checkMedicalCase({
        customer_id: this.formData.customerId,
      }).then(res => {
        console.log(res,"res")
        if(res == true){
          this.formData.case_type = 1
        }else{
          
          this.formData.case_no = res.case_no || ''
          this.formData.department = res.department || ''
          this.formData.case_type = 2
        }
      })
    }
  },
  mounted() {
    
    const { detail, isEdit, caseId ,medical_title} = this.$route.query
    try {
      this.medical_title = '欣 奕 医 疗';
      if (detail) {
        this.customerDetail = JSON.parse(detail)
        console.log(this.customerDetail,"客户信息1")
        this.customerInfo = this.customerDetail
        this.medical_title = this.customerDetail.medical_title || '欣 奕 医 疗'
        this.formData.customerId =  this.customerDetail.id
        this.formData.customer_name = this.customerDetail.customer_name || ''
        this.formData.customer_sex = this.customerDetail.sex || null
        this.formData.age = this.customerDetail.age || ''
      }
    } catch (e) {
      console.error('解析客户信息失败:', e)
    }
    if (caseId || isEdit === 'true') {
      this.isEditMode = true
      this.formData.case_id = caseId 
    } else {
      this.isFirstCase()
      if(this.userInfo.shop_person_id){
        this.getPersonSign()
      }
    }
   
    this.chiefRemoteMethod()
    this.meRecordRemoteMethod()
    this.personalRecordRemoteMethod()
    this.familyRecordRemoteMethod()
    this.physicalExaminationRecordRemoteMethod()
    this.getCaseList()
  },
  beforeDestroy() {
  }
};
</script>

<style lang="scss" scoped>
.btn-wrapper {
  text-align: right;  /* 按钮靠右对齐 */
  margin-top: 12px;   /* 与上方内容保持间距 */
}
.return {
  position: fixed;
  right: 20px;
  top: 71px;
  z-index: 999;
  .backImg {
    margin-right: 14px;
    width: 32px;
    height: 100%;
    cursor: pointer;
    vertical-align: middle;
  }
}
.page-container {
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
}

.paper-form {
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 20px 0;
  background: #ffffff;
  border: 1px solid #333;
  box-sizing: border-box;
}

.form-title {
  text-align: center;
  margin-bottom: 25px;
  border-bottom: 1px solid #999;
  padding-bottom: 15px;

  h2 {
    font-size: 20px;
    margin: 0 0 6px;
    font-weight: bold;
  }
}

.form-row {
  display: flex;
  border-bottom: 1px dashed #333;
  padding: 16px 30px;
  align-items: flex-start;
}

.form-label {
  width: 100px;
  font-weight: bold;
  line-height: 32px;
  text-align: left;
}

.form-content {
  flex: 1;
  min-width: 0;
}

.select-tip-wrapper {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 0;

  .tip-icon {
    font-size: 12px;
    color: #666;
    font-weight: normal;
  }

  .select-template {
    flex: 1;
    max-width: 500px;
  }
}

.textarea-content {
  ::v-deep .el-textarea__inner {
    border: 1px solid #333;
    border-radius: 0;
    font-size: 12px;
    line-height: 1.5;
  }
}

::v-deep .el-input__inner {
  border: none;
  border-bottom: 1px solid #333;
  border-radius: 0;
}

::v-deep .el-textarea__inner {
  border: 1px solid #333;
  border-radius: 0;
  min-height: 50px;
}

.sub-label {
  font-weight: bold;
  margin: 12px 0 8px 0;
  font-size: 13px;
  color: #333;
}

.check-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 20px;
  padding: 4px 0;
  margin-bottom: 8px;
}

.check-item {
  display: flex;
  align-items: center;
  gap: 6px;

  .text {
    white-space: nowrap;
    font-size: 13px;
  }

  .input-inline {
    width: 150px;
    ::v-deep .el-input__inner {
      border: 1px solid #dcdfe6;
      border-radius: 2px;
      height: 28px;
      line-height: 28px;
    }
  }
}

.date-picker {
  width: 220px;
}

.doctor-input {
  max-width: 300px;

  ::v-deep .el-input__inner {
    border: 1px solid #dcdfe6;
    border-radius: 2px;
    height: 32px;
    line-height: 32px;
  }
}

.tips-text {
  margin: 15px 0;
  padding: 8px 12px;
  font-size: 13px;
  line-height: 1.6;

  i {
    margin-right: 6px;
  }
}

.btn-group {
  text-align: center;
  margin-top: 25px;
  padding-top: 15px;
}
</style>